import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@ts-core/components/Dialog';
import SubjectsPanel from '@ts-core/components/SubjectsPanel';

import SubjectForm from 'modules/subjects/components/SubjectForm';

const ProfessorSubjectsPanel = (props) => {
  const { addingSubject, editingSubject, dialogProps, onCreateSubject, onUpdateSubject, ...subjectPanelProps } = props;
  const { dialogData } = dialogProps;

  const handleSubmitSubject = useCallback(
    (input) => {
      const { subject } = dialogData;
      if (subject._id) {
        onUpdateSubject(subject._id, input);
      } else {
        onCreateSubject({ ...input, parentSubject: subject.parentSubject, order: subject.order });
      }
    },
    [dialogData, onCreateSubject, onUpdateSubject]
  );

  return (
    <>
      <SubjectsPanel {...subjectPanelProps} />
      <Dialog {...dialogProps}>
        {(data) => <SubjectForm subject={data.subject} onSubmit={handleSubmitSubject} loading={addingSubject || editingSubject} />}
      </Dialog>
    </>
  );
};

ProfessorSubjectsPanel.propTypes = {
  onAddSubject: PropTypes.func,
  onEditSubject: PropTypes.func,
  onRemoveSubject: PropTypes.func,

  onCreateSubject: PropTypes.func,
  onUpdateSubject: PropTypes.func,

  addingSubject: PropTypes.bool,
  editingSubject: PropTypes.bool,

  dialogProps: PropTypes.object.isRequired,
};

ProfessorSubjectsPanel.defaultProps = {
  onAddSubject: undefined,
  onEditSubject: undefined,
  onRemoveSubject: undefined,

  addingSubject: false,
  editingSubject: false,
};

export default ProfessorSubjectsPanel;
